import React from 'react'

import { ContentWrap, Title } from './styled'
import { NotificationsData } from './NotificationsData'

import Layout from 'src/components/Layout/Layout'
import { NotificationsResponse } from 'src/api/notifications/types'
import { getNotifications } from 'src/api/notifications/notifications'
import { LoadingBlock } from 'src/components/Loading'

export const Notifications: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(true)
  const [notifications, setNotifications] = React.useState<
    NotificationsResponse
  >()

  const fetchNotifications = React.useCallback(async () => {
    setIsLoading(true)
    try {
      const notificationsResponse = await getNotifications()
      setNotifications(notificationsResponse)
    } catch (e) {
      console.error('unhandled error', e)
    }
    setIsLoading(false)
  }, [])

  React.useEffect(() => {
    fetchNotifications()
  }, [fetchNotifications])

  const handleGetMore = async () => {
    if (notifications) {
      const nextPage = {
        skip: notifications.data.length,
      }
      try {
        const nextPageNotifications = await getNotifications(nextPage)

        setNotifications({
          ...nextPageNotifications,
          data: notifications.data.concat(nextPageNotifications.data),
        })
      } catch (e) {
        console.error('unhandled error', e)
      }
    }
  }

  return (
    <Layout>
      <ContentWrap>
        <Title>Notifications</Title>
        {isLoading ? (
          <LoadingBlock />
        ) : (
          <NotificationsData
            notifications={notifications?.data ?? []}
            total={notifications?.total || 0}
            getMore={handleGetMore}
            refetchNotifications={fetchNotifications}
          />
        )}
      </ContentWrap>
    </Layout>
  )
}
